// javascript-obfuscator:disable
import { ComponentType } from "react";
import dynamic from "next/dynamic";

const HightlightMap: Record<string, ComponentType<any>> = {
  columncontrol: dynamic(() => import("./HighlightCategory"), {
    ssr: false,
  }),
};

export default HightlightMap;
